import { render, staticRenderFns } from "./TreeMozambique.vue?vue&type=template&id=787a3596&scoped=true&"
import script from "./TreeMozambique.vue?vue&type=script&lang=js&"
export * from "./TreeMozambique.vue?vue&type=script&lang=js&"
import style0 from "./TreeMozambique.vue?vue&type=style&index=0&id=787a3596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787a3596",
  null
  
)

export default component.exports